module.exports = __webpack_public_path__ + "media/images/lp_consultation/correlation-diagram-device-large-93dcae7b66f7a78d8677beb68eaf0fd3.png";